import { render, staticRenderFns } from "./LightPushButton.vue?vue&type=template&id=0b2d8659&scoped=true&"
import script from "./LightPushButton.vue?vue&type=script&lang=ts&"
export * from "./LightPushButton.vue?vue&type=script&lang=ts&"
import style0 from "./LightPushButton.vue?vue&type=style&index=0&id=0b2d8659&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d8659",
  null
  
)

export default component.exports